import { useCallback, useEffect, useRef } from 'react';

export default function useIsMounted(): () => boolean {
  const mountedRef = useRef<boolean>(false);
  const isMounted = useCallback(() => mountedRef.current, []);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return isMounted;
}
